import { safeWindow } from '../safeWindow';

export type SearchParamValue = string | number | boolean | null | undefined;

export const getSearchParams = () => {
  const search = safeWindow().document?.location.search;
  const params = new URLSearchParams(search);

  return params;
};

const isSearchParamValue = (value: unknown): value is SearchParamValue => (
  value === null
  || value === undefined
  || typeof value === 'string'
  || typeof value === 'number'
  || typeof value === 'boolean'
);

const toComparableValue = (value: unknown): string | undefined => {
  if (!isSearchParamValue(value) || value === null || value === undefined) {
    return undefined;
  }

  return String(value);
};

export const haveSearchParamsChanged = (
  paramNames?: string[],
  previousSearchParams?: Record<string, unknown>,
): boolean => {
  if (!paramNames?.length) {
    return false;
  }

  const currentSearchParams = getSearchParams();

  return paramNames.some((paramName) => (
    (currentSearchParams.get(paramName) ?? undefined) !== toComparableValue(previousSearchParams?.[paramName])
  ));
};
